import { MenuFoldOutlined, MenuUnfoldOutlined, CoffeeOutlined, ShoppingOutlined, EnvironmentOutlined, TagsOutlined, AppstoreOutlined, ShoppingCartOutlined, UserOutlined, HomeOutlined, FileTextOutlined, ClockCircleOutlined, CarOutlined, LogoutOutlined, InboxOutlined, BankOutlined, InstagramOutlined, FacebookOutlined, GiftOutlined } from '@ant-design/icons';
import { Button, Layout, theme, ConfigProvider, InputNumber } from 'antd';
import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import BottledDrinkManagement from './pages/BottledDrinkManagement';
import CoffeeManagement from './pages/CoffeeManagement';
import CollectionManagement from './pages/CollectionManagement';
import FlavorManagement from './pages/FlavorManagement';
import LoginPage from './pages/LoginPage';
import OrderManagement from './pages/OrderManagement';
import RegionManagement from './pages/RegionManagement';
import UserManagement from './pages/UserManagement';
import OrderDetail from './pages/OrderDetail';
import HomeManagement from './pages/HomeManagement';
import PostManagement from './pages/PostManagement';
import BroadcastManagement from './pages/BroadcastManagement';
import MessageManagement from './pages/MessageManagement';
import ZaloTemplateManagement from './pages/ZaloTemplateManagement';
import ZaloTemplateCreatePage from './pages/ZaloTemplateCreatePage';
import GiftManagement from './pages/GiftManagement';
import BusinessHoursManagement from './pages/BusinessHoursManagement';
import ShippingManagement from './pages/ShippingManagement';
import StoreManagement from './pages/StoreManagement';
import { ProductManager } from './pages/ProductManager';
import Sidebar from './components/Sidebar';
import DishManagement from './pages/DishManagement';
import GroupManagement from './pages/GroupManagement';
import TypeManagement from './pages/TypeManagement';
import CityManagement from './pages/CityManagement';
// import SocialMediaManagement from './pages/SocialMediaManagement';
import FacebookManagement from './pages/FacebookManagement';
import InstagramManagement from './pages/InstagramManagement';
import CustomizationManagement from './pages/CustomizationManagement';
import VATManagement from './pages/VATManagement';
import GrinderManagement from './pages/GrinderManagement';
import BrewerManagement from './pages/BrewerManagement';
import CoffeeEquipmentManagement from './pages/CoffeeEquipmentManagement';
import InvoiceManagement from './pages/InvoiceManagement';
import CukcukImportPage from './pages/CukcukImportPage';
import RecipeManagement from './pages/RecipeManagement';
import IngredientManagement from './pages/IngredientManagement';
import PurchaseReceiptManagementPage from './pages/PurchaseReceiptManagementPage';
import CukcukMappingManagementPage from './pages/CukcukMappingManagementPage';
import EmployeeRoleManagement from './pages/EmployeeRoleManagement';
import ScheduleRegistrationEngine from './pages/ScheduleRegistrationEngine';
import Branch2LoginPage from './pages/Branch2LoginPage';
import Branch2InvoiceEntry from './pages/Branch2InvoiceEntry';
import Branch2ProtectedRoute from './components/Branch2ProtectedRoute';
import { formatInputNumberFormatter, parseFlexibleNumber } from './utils/numberInput';
const { Content } = Layout;

const inputNumberDefaultProps = (InputNumber as any).defaultProps || {};

(InputNumber as any).defaultProps = {
  ...inputNumberDefaultProps,
  formatter: inputNumberDefaultProps.formatter || formatInputNumberFormatter(6),
  parser:
    inputNumberDefaultProps.parser ||
    ((displayValue: string | undefined) => parseFlexibleNumber(displayValue) as any),
};

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isAuthenticated = localStorage.getItem('isAuthenticated8Am') === 'true';
  const { token } = theme.useToken();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated8Am');
    navigate('/login');
  };

  useEffect(() => {
    const updateLoginTime = () => {
      if (isAuthenticated) {
        localStorage.setItem('loginTime8Am', Date.now().toString());
      }
    };

    // Update time on user interaction
    window.addEventListener('click', updateLoginTime);
    window.addEventListener('keypress', updateLoginTime);
    window.addEventListener('scroll', updateLoginTime);
    window.addEventListener('mousemove', updateLoginTime);

    return () => {
      window.removeEventListener('click', updateLoginTime);
      window.removeEventListener('keypress', updateLoginTime);
      window.removeEventListener('scroll', updateLoginTime);
      window.removeEventListener('mousemove', updateLoginTime);
    };
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  const menuItems = [
    {
      key: '/coffee',
      label: 'Quản lý hạt cà phê',
      icon: <CoffeeOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/bottled-drink',
      label: 'Quản lý đồ uống đóng chai',
      icon: <ShoppingOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/region',
      label: 'Quản lý vùng trồng',
      icon: <EnvironmentOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/flavor',
      label: 'Quản lý hương vị',
      icon: <TagsOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/collection',
      label: 'Quản lý tuyển tập',
      icon: <AppstoreOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/order',
      label: 'Quản lý đơn hàng',
      icon: <ShoppingCartOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/user',
      label: 'Quản lý người dùng',
      icon: <UserOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/home-management',
      label: 'Quản lý trang chủ',
      icon: <HomeOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: 'content',
      label: 'Quản lý nội dung',
      icon: <FileTextOutlined style={{ fontSize: '16px' }} />,
      children: [
        { key: '/messages', label: 'Quản lý tin truyền thông', icon: <InboxOutlined style={{ fontSize: '16px' }} /> },
        { key: '/broadcasts', label: 'Quản lý broadcast', icon: <InboxOutlined style={{ fontSize: '16px' }} /> },
        { key: '/gifts', label: 'Quản lý quà tặng', icon: <GiftOutlined style={{ fontSize: '16px' }} /> },
      ]
    },
    {
      key: '/business-hours',
      label: 'Quản lý giờ làm việc',
      icon: <ClockCircleOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/stores',
      label: 'Quản lý cửa hàng',
      icon: <EnvironmentOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/shipping',
      label: 'Quản lý vận chuyển',
      icon: <CarOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/product-manager',
      label: 'Quản lý sản phẩm',
      icon: <ShoppingOutlined style={{ fontSize: '16px' }} />
    },
    {
      key: '/menu-management',
      label: 'Quản lý menu',
      icon: <ShoppingOutlined style={{ fontSize: '16px' }} />,
      children: [
        { key: '/dishes', label: 'Quản lý món ăn', icon: <CoffeeOutlined style={{ fontSize: '16px' }} /> },
        { key: '/group-management', label: 'Quản lý nhóm món', icon: <AppstoreOutlined style={{ fontSize: '16px' }} /> },
        { key: '/type-management', label: 'Quản lý loại món', icon: <TagsOutlined style={{ fontSize: '16px' }} /> },
        { key: '/city-management', label: 'Quản lý thành phố', icon: <BankOutlined style={{ fontSize: '16px' }} /> },
      ]
    },
    {
      key: '/social-media',
      label: 'Quản lý mạng xã hội',
      icon: <BankOutlined style={{ fontSize: '16px' }} />,
      children: [
        { key: '/facebook', label: 'Quản lý facebook', icon: <FacebookOutlined style={{ fontSize: '16px' }} /> },
        { key: '/instagram', label: 'Quản lý instagram', icon: <InstagramOutlined style={{ fontSize: '16px' }} /> },
      ]
    },
  ];

  const isMobile = windowWidth <= 768;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        isMobile={isMobile}
        mobileMenuVisible={mobileMenuVisible}
        setMobileMenuVisible={setMobileMenuVisible}
      />

      <Layout style={{ marginLeft: isMobile ? 0 : (collapsed ? 80 : 200), transition: 'all 0.2s' }}>
        <div style={{
          padding: '0 24px',
          height: '64px',
          display: 'flex',
          alignItems: 'center',
          background: '#fff',
          boxShadow: '0 1px 4px rgba(0,21,41,.08)',
          paddingTop: '0px'
        }}>
          {isMobile ? (
            <Button
              type="text"
              icon={<MenuUnfoldOutlined />}
              onClick={() => setMobileMenuVisible(true)}
            />
          ) : (
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
            />
          )}
        </div>
        <Content style={{
          padding: isMobile ? '12px' : '24px',
          background: '#fff',
          margin: '0px',
          minHeight: 280,
          borderRadius: '8px',
          boxShadow: '0 1px 2px 0 rgba(0,0,0,0.03)',
          paddingTop: '0px',
        }}>
          <Routes>
            <Route path="/" element={<Navigate to="/coffee" replace />} />
            <Route path="/coffee" element={<ProtectedRoute><CoffeeManagement /></ProtectedRoute>} />
            <Route path="/bottled-drink" element={<ProtectedRoute><BottledDrinkManagement /></ProtectedRoute>} />
            <Route path="/region" element={<ProtectedRoute><RegionManagement /></ProtectedRoute>} />
            <Route path="/flavor" element={<ProtectedRoute><FlavorManagement /></ProtectedRoute>} />
            <Route path="/collection" element={<ProtectedRoute><CollectionManagement /></ProtectedRoute>} />
            <Route path="/order" element={<ProtectedRoute><OrderManagement /></ProtectedRoute>} />
            <Route path="/invoice-management" element={<ProtectedRoute><InvoiceManagement /></ProtectedRoute>} />
            <Route path="/cukcuk/menu" element={<ProtectedRoute><CukcukImportPage view="menu" /></ProtectedRoute>} />
            <Route path="/cukcuk/hoa-don" element={<ProtectedRoute><CukcukImportPage view="invoice" /></ProtectedRoute>} />
            <Route path="/import-cukcuk" element={<Navigate to="/cukcuk/menu" replace />} />
            <Route path="/cukcuk-import" element={<Navigate to="/cukcuk/menu" replace />} />
            <Route path="/recipes" element={<ProtectedRoute><RecipeManagement /></ProtectedRoute>} />
            <Route path="/ingredient-management" element={<ProtectedRoute><IngredientManagement /></ProtectedRoute>} />
            <Route path="/purchase-receipts" element={<ProtectedRoute><PurchaseReceiptManagementPage /></ProtectedRoute>} />
            <Route path="/cukcuk/mapping" element={<ProtectedRoute><CukcukMappingManagementPage /></ProtectedRoute>} />
            <Route path="/user" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
            <Route path="/employee-management" element={<Navigate to="/employee-role-management" replace />} />
            <Route path="/employee-role-management" element={<ProtectedRoute><EmployeeRoleManagement /></ProtectedRoute>} />
            <Route path="/schedule-registration-engine" element={<ProtectedRoute><ScheduleRegistrationEngine /></ProtectedRoute>} />
            <Route path="/order/:id" element={<OrderDetail />} />
            <Route path="/home-management" element={<ProtectedRoute><HomeManagement /></ProtectedRoute>} />
            <Route path="/posts" element={<ProtectedRoute><PostManagement /></ProtectedRoute>} />
            <Route path="/broadcasts" element={<ProtectedRoute><BroadcastManagement /></ProtectedRoute>} />
            <Route path="/gifts" element={<ProtectedRoute><GiftManagement /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute><MessageManagement /></ProtectedRoute>} />
            <Route path="/zalo-templates" element={<ProtectedRoute><ZaloTemplateManagement /></ProtectedRoute>} />
            <Route path="/zalo-templates/create" element={<ProtectedRoute><ZaloTemplateCreatePage /></ProtectedRoute>} />
            <Route path="/business-hours" element={<ProtectedRoute><BusinessHoursManagement /></ProtectedRoute>} />
            <Route path="/stores" element={<ProtectedRoute><StoreManagement /></ProtectedRoute>} />
            <Route path="/shipping" element={<ProtectedRoute><ShippingManagement /></ProtectedRoute>} />
            {/* <Route path="/product-manager" element={<ProtectedRoute><ProductManager /></ProtectedRoute>} /> */}
            <Route path="/dishes" element={<ProtectedRoute><DishManagement /></ProtectedRoute>} />
            <Route path="/groups" element={<ProtectedRoute><GroupManagement /></ProtectedRoute>} />
            <Route path="/types" element={<ProtectedRoute><TypeManagement /></ProtectedRoute>} />
            <Route path="/city-management" element={<ProtectedRoute><CityManagement /></ProtectedRoute>} />
            <Route path="/facebook" element={<ProtectedRoute><FacebookManagement /></ProtectedRoute>} />
            <Route path="/instagram" element={<ProtectedRoute><InstagramManagement /></ProtectedRoute>} />
            <Route path="/customization" element={<ProtectedRoute><CustomizationManagement /></ProtectedRoute>} />
            <Route path="/vat-management" element={<ProtectedRoute><VATManagement /></ProtectedRoute>} />
            <Route path="/coffee-equipment" element={<ProtectedRoute><CoffeeEquipmentManagement /></ProtectedRoute>} />
            <Route path="/grinder" element={<ProtectedRoute><GrinderManagement /></ProtectedRoute>} />
            <Route path="/brewer" element={<ProtectedRoute><BrewerManagement /></ProtectedRoute>} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

function App() {
  const fontFamily = '"Inter", "Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: fontFamily,
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/branch2-login" element={<Branch2LoginPage />} />
          <Route
            path="/branch2-entry"
            element={
              <Branch2ProtectedRoute>
                <Branch2InvoiceEntry />
              </Branch2ProtectedRoute>
            }
          />
          <Route path="/order/:id" element={<OrderDetail />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppContent />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/coffee" replace />} />
            <Route path="/coffee" element={<CoffeeManagement />} />
            <Route path="/bottled-drink" element={<BottledDrinkManagement />} />
            <Route path="/region" element={<RegionManagement />} />
            <Route path="/flavor" element={<FlavorManagement />} />
            <Route path="/collection" element={<CollectionManagement />} />
            <Route path="/order" element={<OrderManagement />} />
            <Route path="/invoice-management" element={<InvoiceManagement />} />
            <Route path="/cukcuk/menu" element={<CukcukImportPage view="menu" />} />
            <Route path="/cukcuk/hoa-don" element={<CukcukImportPage view="invoice" />} />
            <Route path="/import-cukcuk" element={<Navigate to="/cukcuk/menu" replace />} />
            <Route path="/cukcuk-import" element={<Navigate to="/cukcuk/menu" replace />} />
            <Route path="/recipes" element={<RecipeManagement />} />
            <Route path="/ingredient-management" element={<IngredientManagement />} />
            <Route path="/purchase-receipts" element={<PurchaseReceiptManagementPage />} />
            <Route path="/cukcuk/mapping" element={<CukcukMappingManagementPage />} />
            <Route path="/user" element={<UserManagement />} />
            <Route path="/employee-management" element={<Navigate to="/employee-role-management" replace />} />
            <Route path="/employee-role-management" element={<EmployeeRoleManagement />} />
            <Route path="/schedule-registration-engine" element={<ScheduleRegistrationEngine />} />
            <Route path="/home-management" element={<HomeManagement />} />
            <Route path="/posts" element={<PostManagement />} />
            <Route path="/broadcasts" element={<BroadcastManagement />} />
            <Route path="/gifts" element={<GiftManagement />} />
            <Route path="/messages" element={<MessageManagement />} />
            <Route path="/zalo-templates" element={<ZaloTemplateManagement />} />
            <Route path="/zalo-templates/create" element={<ZaloTemplateCreatePage />} />
            <Route path="/business-hours" element={<BusinessHoursManagement />} />
            <Route path="/stores" element={<StoreManagement />} />
            <Route path="/shipping" element={<ShippingManagement />} />
            {/* <Route path="/product-manager" element={<ProductManager />} /> */}
            <Route path="/dishes" element={<DishManagement />} />
            <Route path="/groups" element={<GroupManagement />} />
            <Route path="/types" element={<TypeManagement />} />
            <Route path="/city-management" element={<CityManagement />} />
            <Route path="/facebook" element={<FacebookManagement />} />
            <Route path="/instagram" element={<InstagramManagement />} />
            <Route path="/customization" element={<CustomizationManagement />} />
            <Route path="/vat-management" element={<VATManagement />} />
            <Route path="/coffee-equipment" element={<CoffeeEquipmentManagement />} />
            <Route path="/grinder" element={<GrinderManagement />} />
            <Route path="/brewer" element={<BrewerManagement />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
